import { LoadingDots } from '../../../../../app-kit/components/LoadingDots/LoadingDots';
import { Button, type ButtonProps } from '@property.com.au/ui-kit';
import type { FunctionComponent, PropsWithChildren } from 'react';
import styled, { css } from 'styled-components';

const ButtonWrapper = styled.div`
  position: relative;
`;

const StyledButton = styled(Button)<{ $isLoading: boolean }>`
  ${({ $isLoading }) =>
    $isLoading &&
    css`
      & > span,
      & > svg {
        visibility: hidden;
      }
    `}
`;

const LoadingDotsWrapper = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;

interface ButtonWithLoadingStateProps
  extends ButtonProps,
    React.ButtonHTMLAttributes<HTMLButtonElement> {
  isLoading: boolean;
}

export const ButtonWithLoadingState: FunctionComponent<
  PropsWithChildren<ButtonWithLoadingStateProps>
> = ({ isLoading, children, ...rest }) => {
  return (
    <ButtonWrapper>
      <StyledButton {...rest} $isLoading={isLoading} disabled={isLoading}>
        {children}
      </StyledButton>
      {isLoading && (
        <LoadingDotsWrapper>
          <LoadingDots />
        </LoadingDotsWrapper>
      )}
    </ButtonWrapper>
  );
};
